import React, { useCallback } from "react";

import ExportListPanel from "fond/export/ExportListPanel";
import { Export } from "fond/types";

const ConstructionPrintExport: React.FC = () => {
  const filterExport = useCallback((e: Export) => !!e.ConstructionPrints, []);

  return (
    <ExportListPanel
      title="Export construction prints"
      subtitle="Construction print exports"
      filterExport={filterExport}
      exportNamePrefix="ConstructionPrints"
      exportDescription="Export of construction prints"
      createExportOverrides={{ ConstructionPrints: { Type: "standard" } }}
      noExportsMessage='There are no construction print exports yet. Click "Create New Export" to get started.'
    />
  );
};

export default ConstructionPrintExport;
